import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation} from '@angular/core';
import {SafeResourcePipe} from "../../pipes";
import {SvgService} from "../../services/svg.service";
import {NgClass, NgIf} from "@angular/common";

@Component({
  selector: 'svg-loader',
  standalone: true,
  imports: [
    SafeResourcePipe,
    NgIf,
    NgClass
  ],
  providers: [SvgService],
  template: `
    <div *ngIf="safeSvgContent" class="container-svg" [ngClass]="containerClass" [innerHTML]="safeSvgContent | safeResource : 'html' "></div>
  `,
  styles: `
    .container-svg{
      width: 100%;
    }
  `,
  host: {'[attr.data-component-id]': 'idComponent'},
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class SvgLoaderComponent {

  idComponent: string;

  @Input() set name(value: string) {
    this._name = value;
    this.getResource()
  }

  @Input ('containerClass') containerClass:  string | string[] | Set<string> | {[p: string]: any} | null | undefined;

  private _name: string | null = null;
  protected safeSvgContent: string = '';

  constructor(private svgService: SvgService, private cdr: ChangeDetectorRef  ) {
    this.idComponent= Math.random().toString(36).slice(2, 8) + 'ID';
  }

  getResource() {
    if (this._name)
      this.svgService.loadSvg(this._name).subscribe(svg => {
        this.safeSvgContent = svg
        this.cdr.detectChanges()
      })
  }


}
